import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

import { PaymentEvent } from '../models';


@Injectable({
  providedIn: 'root'
})
export class PaymentEventService {
  public paid = new Subject<PaymentEvent>();
  constructor() { }
}
